import { 
  createAsyncThunk,
  createSelector,
  createSlice,
  createEntityAdapter,
} from '@reduxjs/toolkit'
import { getNotices } from '../api/kquake'

const noticesAdapter = createEntityAdapter({
  sortComparer: (a, b) => a.lastModified.localeCompare(b.lastModified) * (-1),
})

const initialState = noticesAdapter.getInitialState({
  fetchStatus: 'idle',
  fetchError: null,
})

export const fetchNotices = createAsyncThunk('notices/fetchNotices', async (_, { getState }) => {
    const response = await getNotices()
    return response
})

const noticesSlice = createSlice({
  name: 'notices',
  initialState,
  reducers: {
    
  },
  extraReducers: {
    [fetchNotices.pending]: (state, action) => {
      state.fetchStatus = 'loading'
    },
    [fetchNotices.fulfilled]: (state, action) => {
      state.fetchStatus = 'succeeded'
      noticesAdapter.upsertMany(state, action.payload)
    },
    [fetchNotices.rejected]: (state, action) => {
      state.fetchStatus = 'failed'
      console.error('api failed!', action)
      state.fetchError = action.error.message
    },
  },
})

export default noticesSlice.reducer

export const {
  selectAll: selectAllNotices,
  selectById: selectNoticeById,
  selectIds: selectNoticeIds,
} = noticesAdapter.getSelectors((state) => state.notices)

export const selectRecentImportantNotices = createSelector(
  [selectAllNotices], ((notices) => {
    let latest;
    for (const notice of notices) {
      if (notice.important) {
        if (latest) {
          if (latest.lastModified < notice.lastModified) {
            latest = notice
          }
        } else {
          latest = notice
        }
      }
    }
    return latest
  })
 )
